<template>
  <div class="app-main-inner app-main-page basic-data china-post-product-configuration">
    <el-container class="app-main-inner-row">
      <el-aside
        class="inner-box"
        style="width:fit-content;height:calc(100vh - 210px);overflow-x: hidden;margin-top: 60px"
      >
        <el-radio-group v-model="currentBar" style="display: flex;flex-direction: column" no="navigationBars" @change="barChange">
          <el-radio
            v-for="(item,index) in navigationBars"
            :key="index"
            :label="item.value"
            style="line-height:30px;"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-aside>
      <el-main style="padding:0px;flex: 1">
        <!--可售卖产品-->
        <allow-sale-product v-show="currentBar === 'AllowSaleProduct'" ref="allowSaleProduct" no="allowSaleProduct" />
        <!--新一代费用组-->
        <new-charge-group v-show="currentBar === 'NewChargeGroup'" ref="newChargeGroup" no="newChargeGroup" />
        <!--新一代费用映射-->
        <charge-mapping v-show="currentBar === 'ChargeMapping'" ref="chargeMapping" no="chargeMapping" />
        <!--新一代接口公司设置-->
        <exclusion-office v-show="currentBar === 'ExclusionOffice'" ref="ExclusionOffice" no="ExclusionOffice" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import allowSaleProduct from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/allowSaleProduct.vue'
import newChargeGroup from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/newChargeGroup.vue'
import chargeMapping from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/chargeMapping.vue'
import exclusionOffice from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/exclusionOffice.vue'
import checkPermission from '@/utils/permission'
import { getUserInfo } from '@/utils/auth'
export default {
  name: 'ChinaPostProductConfiguration',
  components: {
    allowSaleProduct,
    newChargeGroup,
    chargeMapping,
    exclusionOffice
  },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      navigationBars: [],
      currentBar: '',
      tenantId: ''
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    const isPlatform = this.tenantId === this.PLATFORM_TENANT_ID
    const bars = []
    bars.push({ label: this.$t('CargoMsg.AllowSaleProduct'), englishLabel: 'Allow Sale Product', value: 'AllowSaleProduct' })
    bars.push({ label: this.$t('CargoMsg.NewChargeGroup'), englishLabel: 'New Charge Group', value: 'NewChargeGroup' })
    bars.push({ label: this.$t('CargoMsg.ChargeMapping'), englishLabel: 'Charge Mapping', value: 'ChargeMapping' })
    bars.push({ label: this.$t('CargoMsg.ExclusionOffice'), englishLabel: 'Exclusion Office', value: 'ExclusionOffice' })
    if (this.$i18n.locale !== 'zh') {
      bars.forEach(function(item) {
        item.label = item.englishLabel
      })
    }
    if (user.admin) {
      this.navigationBars = bars
    } else {
      this.navigationBars = bars.filter(p => checkPermission([`button_${p.value}_read`]))
    }
    this.currentBar = 'AllowSaleProduct'
  },
  mounted() {
    this.barChange()
  },
  methods: {
    barChange() {
      switch (this.currentBar) {
        case 'AllowSaleProduct':
          this.$refs.allowSaleProduct.onShow()
          break
        case 'NewChargeGroup':
          this.$refs.newChargeGroup.onShow()
          break
        case 'ChargeMapping':
          this.$refs.chargeMapping.onShow()
          break
        case 'ExclusionOffice':
          this.$refs.ExclusionOffice.onShow()
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-data {
  /*--滚动条样式 begin--*/
  .el-main{
    &>div{
      display: flex;
      flex-direction: column;
      height: 100%;
      .row-grid{
        flex-grow: 1;
      }
    }
  }
  .inner-box {
  }

  .inner-box::-webkit-scrollbar,
  .el-dialog__wrapper::-webkit-scrollbar {
    /*滚动条整体样式，宽高分别对应横竖滚动条的尺寸*/
    width: 6px;
    height: 6px;
  }

  .inner-box::-webkit-scrollbar-thumb,
  .el-dialog__wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 3px;
    background-color: #545557;
  }

  .inner-box::-webkit-scrollbar-track,
  .el-dialog__wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background-color: #dcdfe6;
  }

  /*--滚动条样式 end--*/
}
</style>
